import Logo from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const coverUrl = (release) =>
    release?.cover_path ? `${API}/files/${release.cover_path}` : null;

export const CoverImage = ({ release, className = "" }) => {
    const src = coverUrl(release);
    if (src) {
        return <img src={src} alt={`${release.title} cover art`} loading="lazy" className={className} />;
    }
    return (
        <div
            className={`${className} bg-gradient-to-br from-zinc-900 via-[#17130a] to-black flex flex-col items-center justify-center gap-3`}
            role="img"
            aria-label={`${release.title} cover art coming soon`}
        >
            <Logo size={56} className="opacity-70" />
            <span className="font-meta text-[10px] tracking-[0.35em] uppercase text-amber-500/60">Cover Coming Soon</span>
        </div>
    );
};

export default CoverImage;
